import React from 'react';
import { useNavigate } from 'react-router-dom';
import { createTrcContentApi } from '@/data/api/trc';
import { handleErrorResponse } from '@/utils/handleErrorResponse';
import { buildRoutes } from '@/service/buildRoutes';
import ProduceTRCContent from './components/ProduceTRCContent';

const AddContent = () => {
  const navigate = useNavigate();

  const handleCreate = async (payload) => {
    const response = await createTrcContentApi(payload);

    if (handleErrorResponse(response)) {
      throw new Error('Create TRC content failed');
    }
    navigate(buildRoutes.toTRCContent());
  };

  return (
    <ProduceTRCContent
      mode="create"
      initialValues={null}
      onSubmit={handleCreate}
      labels={{
        title: 'Add Content',
        submit: 'Save',
        reset: 'Reset',
        successCreate: 'Content added successfully.'
      }}
    />
  );
};

export default AddContent;
